import { render, staticRenderFns } from "./ReportArhiveObjectFullInform.vue?vue&type=template&id=1eea263f&scoped=true&"
import script from "./ReportArhiveObjectFullInform.vue?vue&type=script&lang=js&"
export * from "./ReportArhiveObjectFullInform.vue?vue&type=script&lang=js&"
import style0 from "./ReportArhiveObjectFullInform.vue?vue&type=style&index=0&id=1eea263f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eea263f",
  null
  
)

export default component.exports
import {QItem,QCard,QCardSection,QBtn,QBanner,QExpansionItem,QItemSection,QSpinnerGears,QItemLabel,QLinearProgress,QImg,QTooltip,QTable,QTr,QTd,QSeparator,QList,QTree} from 'quasar'
component.options.components = Object.assign({QItem,QCard,QCardSection,QBtn,QBanner,QExpansionItem,QItemSection,QSpinnerGears,QItemLabel,QLinearProgress,QImg,QTooltip,QTable,QTr,QTd,QSeparator,QList,QTree}, component.options.components || {})
